
import { User as SupabaseUser } from "@supabase/supabase-js";
import { User } from "@/types";

/**
 * Adapts a Supabase user to our application's User type
 */
export const adaptSupabaseUser = (supabaseUser: SupabaseUser): User => {
  return {
    id: supabaseUser.id,
    name: supabaseUser.user_metadata?.name || supabaseUser.email?.split('@')[0] || 'User',
    email: supabaseUser.email || '',
    imageUrl: supabaseUser.user_metadata?.avatar_url || null,
  };
};
